import ptBrTranslations from './pt-br'
import enUsTranslations from './en-us'
import esEsTranslations from './es-es'

export default {
  'pt-BR': ptBrTranslations,  // Atente-se a usar as abreviaturas corretas
  'en-US': enUsTranslations,
  'es-ES': esEsTranslations
}